<script>
import myPlanData from '../../../mixins/myPlanData'

export default {
  name: 'PrintButton',
  mixins: [myPlanData]
}
</script>

<template>
  <a
    v-if="isSubscribed"
    href="javascript:window.print()"
    tag="button"
    class="button is-pulled-right has-text-tertiary is-white is-hidden-print is-hidden-touch"
  >
    <span class="icon">
      <i class="fas fa-print" />
    </span>
    <span>Print results</span>
  </a>
</template>
